<form [formGroup]="registerForm" (ngSubmit)="onSubmit()" class="rayalina-auth-form" novalidate>
    <div class="field">
        <label for="ray-reg-name">Nom complet</label>
        <input id="ray-reg-name" type="text" formControlName="name" autocomplete="name" />
        <span class="field-error" *ngIf="name?.hasError('required') && (name?.touched || formSubmitted)">
            Veuillez entrer votre nom et prénom(s).
        </span>
    </div>

    <div class="field">
        <label for="ray-reg-email">Adresse email</label>
        <input id="ray-reg-email" type="email" formControlName="email" autocomplete="email" />
        <span class="field-error" *ngIf="(email?.hasError('required') || email?.hasError('email')) && (email?.dirty || formSubmitted)">
            Veuillez entrer une adresse email valide.
        </span>
    </div>

    <div class="field">
        <label for="ray-reg-phone">Numéro de téléphone</label>
        <div class="rayalina-intl-input">
            <intl-tel-input
                formControlName="phonePrimary"
                [inputProps]="{ id: 'ray-reg-phone', autocomplete: 'tel' }"
                [initOptions]="intlTelOptions"
            ></intl-tel-input>
        </div>
        <span
            class="field-error"
            *ngIf="
                (phonePrimary?.hasError('required') && (phonePrimary?.touched || formSubmitted)) ||
                phonePrimary?.hasError('validatePhoneNumber')
            "
        >
            Veuillez entrer un numéro de téléphone valide.
        </span>
    </div>

    <div class="field">
        <label for="ray-reg-password">Mot de passe</label>
        <div class="password-row">
            <input
                id="ray-reg-password"
                [type]="isShowPass[0] ? 'text' : 'password'"
                formControlName="password"
                autocomplete="new-password"
                placeholder="Min. 6 caractères"
            />
            <button type="button" class="toggle-visibility" (click)="handleShowPass(0)" [attr.aria-pressed]="isShowPass[0]">
                <i class="bx" [class.bx-show]="!isShowPass[0]" [class.bx-hide]="isShowPass[0]"></i>
            </button>
        </div>
        <span
            class="field-error"
            *ngIf="
                (password?.hasError('required') && password?.touched) ||
                (password?.errors?.['minlength'] && password?.dirty) ||
                (formSubmitted && !password?.value)
            "
        >
            Veuillez entrer un mot de passe d’au moins 6 caractères.
        </span>
    </div>

    <div class="field">
        <label for="ray-reg-password2">Confirmer le mot de passe</label>
        <div class="password-row">
            <input
                id="ray-reg-password2"
                [type]="isShowPass[1] ? 'text' : 'password'"
                formControlName="passwordConfirm"
                autocomplete="new-password"
            />
            <button type="button" class="toggle-visibility" (click)="handleShowPass(1)" [attr.aria-pressed]="isShowPass[1]">
                <i class="bx" [class.bx-show]="!isShowPass[1]" [class.bx-hide]="isShowPass[1]"></i>
            </button>
        </div>
        <span class="field-error" *ngIf="passwordConfirm?.hasError('required') && (passwordConfirm?.touched || formSubmitted)">
            Veuillez confirmer votre mot de passe.
        </span>
        <span
            class="field-error"
            *ngIf="passwordConfirm?.touched && registerForm.errors?.['passwordDoNotMatch']"
        >
            Les mots de passe ne correspondent pas.
        </span>
    </div>

    <div class="terms-row">
        <input id="ray-reg-terms" type="checkbox" formControlName="acceptTerms" />
        <label for="ray-reg-terms">
            J’accepte les <a href="#" (click)="$event.preventDefault()">conditions d’utilisation</a> et la politique de confidentialité de Rayalina.
        </label>
    </div>
    <span class="field-error" *ngIf="acceptTerms?.invalid && formSubmitted">Vous devez accepter les conditions pour continuer.</span>

    <p class="form-banner-error" *ngIf="errorMessage">{{ errorMessage }}</p>

    <button type="submit" class="submit-btn" [disabled]="loading">
        {{ loading ? "Inscription…" : "S’inscrire" }}
    </button>
</form>
